import React, { useLayoutEffect, useState } from "react";
import { Navigate, Outlet } from "react-router";
import appState from "../service/state/app.state";
import { observer } from "mobx-react-lite";

export const PrivateRoute = observer(() => {
  useLayoutEffect(() => {
    if (localStorage.getItem("at") !== null) {
      appState.setParameters("isAuth", true);
    } else {
      appState.setParameters("isAuth", false);
    }
  }, []);
  if (appState.isAuth) {
    return <Outlet />;
  } else {
    return <Navigate to="/login" />;
  }
});
